import React from 'react';

const PULSE_STYLE = `
  @keyframes streak-pulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(255,159,28,.4); border-color: rgba(255,159,28,.6); }
    50%       { box-shadow: 0 0 10px 3px rgba(255,159,28,.25); border-color: #ff9f1c; }
  }
`;

export default function StreakBadge({ streak }) {
  if (!streak || streak < 1) return null;

  const isHot = streak >= 7;

  return (
    <>
      {isHot && <style>{PULSE_STYLE}</style>}
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '.28rem',
        padding: '.32rem .6rem',
        borderRadius: 99,
        background:  isHot ? 'rgba(255,159,28,.14)' : 'rgba(255,255,255,.06)',
        border: `1.5px solid ${isHot ? 'rgba(255,159,28,.55)' : 'rgba(255,255,255,.12)'}`,
        animation: isHot ? 'streak-pulse 2s ease-in-out infinite' : 'none',
        cursor: 'default',
      }}>
        <span style={{ fontSize: '.95rem', lineHeight: 1 }}>🔥</span>
        <span style={{
          fontFamily: 'var(--font-display)',
          fontSize: '.8rem',
          fontWeight: 700,
          color: isHot ? '#ff9f1c' : 'var(--parch)',
          lineHeight: 1,
        }}>
          {streak}
        </span>
      </div>
    </>
  );
}
